import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";

const apiService = HttpService;

// Initial state of the slice
const initialState = {
  trfDetails: [], // Details of a single stock
  loading: false,
  error: null,
  trfPageInfo: {},
  trfDetailsById: {},
  shortlistTrfByID: {},
  unShortlistTrfByID: {},
  verifyTrfById: {},
  notVerifyTrfById: {},
  rejectTrfById: {},
  getBirlaFiber : [],
  downloadTrf : {}
};

// Async thunk for fetching all TRF lab and marketing
export const fetchAllTrfLabAndTracer = createAsyncThunk(
  "tracer-tests/fetchAllTrfLabAndTracer",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/tracer-tests", {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);
export const fetchAllTrfVCPTracer = createAsyncThunk(
  "tracer-tests/fetchAllTrfVCPTracer",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/tracer-tests", {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);
//fetch/ Get Birla fiber
export const fetchBirlaFiber = createAsyncThunk(
  "tracer-tests/fetchBirlaFiber",
  async ( thunkAPI) => {
    try {
      const response = await apiService.get("/public/lookups/birla-fibre");
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for fetching all TRF lab and marketing
export const fetchTrfById = createAsyncThunk(
  "tracer-tests/fetchTrfById",
  async (id, { rejectWithValue }) => {
    try {
      //  console.log("TRF Query Params", id);
      const response = await apiService.get(`/tracer-tests/${id}`);
      // console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);
// to shortlist the TRF
export const shortlistTrf = createAsyncThunk(
  "tracer-tests/shortlistTrf",
  async ({ trfId, trfData }, { rejectWithValue }) => {
    try {
      //  console.log("TRF Query Params", trfId);
      const response = await apiService.patch(
        `/tracer-tests/${trfId}`,
        trfData
      );
      // console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);
// to UnShortlist the TRF
export const unShortlistTrf = createAsyncThunk(
  "tracer-tests/unShortlistTrf",
  async ({ trfId, trfData }, { rejectWithValue }) => {
    try {
      // console.log("TRF Query Params unSHORTLIST", trfId,trfData);
      const response = await apiService.patch(`/tracer-tests/${trfId}`, trfData);
      console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);
// to Verify the TRF
export const verifyTrf = createAsyncThunk(
  "tracer-tests/verifyTrf",
  async ({ trfId, body }, { rejectWithValue }) => { 
    try {
      // console.log("TRF Query Params verify", trfId,body);
      const response = await apiService.patch(`/tracer-tests/${trfId}`, body);
      // console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);
// to NotVerify the TRF
export const notVerifyTrf = createAsyncThunk(
  "tracer-tests/notVerifyTrf",
  async ({ trfId, body}, { rejectWithValue }) => {
    try {
     // console.log("TRF Query Params for NOT VERIFY ", trfId,body);
      const response = await apiService.patch(`/tracer-tests/${trfId}`, body);
      // console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);
// to Reject the TRF
export const rejectTrf = createAsyncThunk(
  "tracer-tests/rejectTrf",
  async ({ trfId, body }, { rejectWithValue }) => {
    try {
      console.log("TRF Query Params for REJECT ", trfId,body);
      const response = await apiService.patch(`/tracer-tests/${trfId}`, body);
      // console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return rejectWithValue.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);
// to download the lab and marketing excel
export const downloadTrfLabMarketing = createAsyncThunk(
  "tracer-tests/downloadTrfLabMarketing",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get("/tracer-tests", {
        params: queryParams,
      });
      // console.log("response",response)
      return response.data;
    } catch (error) {
      console.log("error : ", error);
      return thunkAPI.rejectWithValue(
        error.response.data || error.message
      );
    }
  }
);

// The TRF slice
export const trfUSerSlice = createSlice({
  name: "tracer-tests",
  initialState,
  reducers: {
    resetStockState: (state) => {
      state.trfDetails = [];
      state.loading = false;
      state.error = null;
      state.trfPageInfo = {};
      state.trfDetailsById = {};
      state.shortlistTrfByID = {};
      state.unShortlistTrfByID = {};
      state.verifyTrfById = {};
      state.notVerifyTrfById = {};
      state.rejectTrfById = {};
      state.getBirlaFiber = [];
      state.downloadTrf = {}
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling all-trfs
      .addCase(fetchAllTrfLabAndTracer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTrfLabAndTracer.fulfilled, (state, action) => {
        state.loading = false;
        state.trfDetails = action.payload.data;
        console.log("in the fulfilled", action.payload.data);
        state.trfPageInfo = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchAllTrfLabAndTracer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // fetch case for Birla Fiber

      .addCase(fetchBirlaFiber.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBirlaFiber.fulfilled, (state, action) => {
        state.loading = false;
        state.getBirlaFiber = action.payload.data;
      })
      .addCase(fetchBirlaFiber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // Handling lab-trfs
      .addCase(fetchAllTrfVCPTracer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTrfVCPTracer.fulfilled, (state, action) => {
        state.loading = false;
        state.trfDetails = action.payload.data;
        console.log("in the fulfilled", action.payload.data);
        state.trfPageInfo = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchAllTrfVCPTracer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // to get the TRF by ID
      .addCase(fetchTrfById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrfById.fulfilled, (state, action) => {
        state.loading = false;
        state.trfDetailsById = action.payload.data;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(fetchTrfById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // to Shortlist the TRF by ID
      .addCase(shortlistTrf.pending, (state) => {
        state.loading = true;
      })
      .addCase(shortlistTrf.fulfilled, (state, action) => {
        state.loading = false;
        state.shortlistTrfByID = action.payload.data;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(shortlistTrf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // to UnShortlist the TRF by ID
      .addCase(unShortlistTrf.pending, (state) => {
        state.loading = true;
      })
      .addCase(unShortlistTrf.fulfilled, (state, action) => {
        state.loading = false;
        state.unShortlistTrfByID = action.payload;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(unShortlistTrf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // to Verify the TRF by ID
      .addCase(verifyTrf.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyTrf.fulfilled, (state, action) => {
        state.loading = false;
        state.verifyTrfById = action.payload.data;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(verifyTrf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // to NotVerify the TRF by ID
      .addCase(notVerifyTrf.pending, (state) => {
        state.loading = true;
      })
      .addCase(notVerifyTrf.fulfilled, (state, action) => {
        state.loading = false;
        state.notVerifyTrfById = action.payload.data;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(notVerifyTrf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // to Reject the TRF by ID
      .addCase(rejectTrf.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectTrf.fulfilled, (state, action) => {
        state.loading = false;
        state.rejectTrfById = action.payload.data;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(rejectTrf.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
       // to download the TRF
       .addCase(downloadTrfLabMarketing.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadTrfLabMarketing.fulfilled, (state, action) => {
        state.loading = false;
        state.downloadTrf = action.payload.data;
        //console.log("in the fulfilled",action.payload.data)
      })
      .addCase(downloadTrfLabMarketing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Ensure this is in a usable format
      });
  },
});

// Export actions and reducer
export const { resetStockState } = trfUSerSlice.actions;
export default trfUSerSlice.reducer;
